var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingEnergyValveGrouplevel = function SvgDHeatingEnergyValveGrouplevel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 592.05,
    y: 102.01,
    width: 28,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.05,
    y: 97.01,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "592.55 99.87 605.04 107 592.56 114.15 592.55 99.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.05,100.73l10.98,6.26-10.97,6.29v-12.55M592.05,99.01v16s14-8.01,14-8.01l-14-7.98h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "607.06 107 619.54 99.87 619.55 114.15 607.06 107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.04,100.73v12.55s-10.98-6.29-10.98-6.29l10.98-6.26M620.04,99.01l-13.99,7.98,14,8.01v-16h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 606.05,
    cy: 86.02,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.05,76.02c5.51,0,10,4.48,10,10s-4.49,10-10,10-10-4.48-10-10,4.49-10,10-10M606.05,75.02c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M608.97,82.67v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 577.05,
    y: 96.99,
    width: 2,
    height: 5.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 606.05,
    cy: 106.99,
    r: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.05,102.99c2.21,0,4,1.79,4,4s-1.79,4-4,4-4-1.79-4-4,1.79-4,4-4M606.05,101.99c-2.76,0-5,2.24-5,5s2.24,5,5,5,5-2.24,5-5-2.24-5-5-5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 588.05,
    y: 98.99,
    width: 4,
    height: 16,
    transform: "translate(1180.1 213.98) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.05,99.99v14h-2v-14h2M592.05,98.99h-4v16h4v-16h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 564.05,
    y: 98.99,
    width: 4,
    height: 16,
    transform: "translate(1132.1 213.98) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.05,99.99v14h-2v-14h2M568.05,98.99h-4v16h4v-16h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 567.05,
    y: 101.99,
    width: 22,
    height: 10,
    transform: "translate(1156.1 213.98) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.05,102.99v8h-20v-8h20M589.05,101.99h-22v10h22v-10h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M577.91,105.77c-3.65,0-7.44-1.09-10.15-2.92l.56-.83c2.55,1.72,6.13,2.75,9.59,2.75s7.11-1.05,9.62-2.75l.56.83c-2.71,1.83-6.51,2.92-10.18,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.53,111.96c-2.51-1.7-6.2-2.75-9.62-2.75s-7.04,1.03-9.59,2.75l-.56-.83c2.71-1.83,6.5-2.92,10.15-2.92s7.47,1.09,10.18,2.92l-.56.83Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 567.05,
    y: 75,
    width: 22,
    height: 21.99,
    transform: "translate(1156.1 171.99) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.05,76v19.99h-20v-19.99h20M589.05,75h-22v21.99h22v-21.99h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M578.12,87.37l1.45-4.45h1.09l-2.05,5.69h-.96l-2.04-5.69h1.08l1.43,4.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.55,
    y: 83.01,
    width: 1,
    height: 6,
    transform: "translate(504.26 677.79) rotate(-89.83)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567 81.01 561.58 79.55 561.58 80.5 557 80.5 557 81.5 561.58 81.5 561.58 82.45 567 81.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567 91.01 561.58 89.55 561.58 90.5 557 90.49 557 91.49 561.58 91.5 561.58 92.45 567 91.01"
  })))));
};
export default SvgDHeatingEnergyValveGrouplevel;